import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiChevronDown, HiChevronUp } from 'react-icons/hi';
import { HiOutlineExclamationTriangle } from 'react-icons/hi2';

import { LegalWarningContent } from '@/components/legal-warning';

export const LegalWarning: FC = () => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="w-full rounded-lg border border-day-light-2 bg-day-light-3 px-5 py-4">
      <button
        type="button"
        onClick={() => setExpanded((value) => !value)}
        className="flex w-full items-center justify-between"
        aria-expanded={expanded}
      >
        <span className="flex items-center gap-2 font-semibold text-day-neutral-dark">
          <HiOutlineExclamationTriangle size={20} />
          {t('legal-warning.title')}
        </span>
        {expanded ? (
          <HiChevronUp size={20} className="text-day-neutral-subtle" />
        ) : (
          <HiChevronDown size={20} className="text-day-neutral-subtle" />
        )}
      </button>

      {expanded && (
        <div className="mt-3">
          <LegalWarningContent />
        </div>
      )}
    </div>
  );
};
